import API from "./index";

class EstadoConservacaoIBPService {
  constructor() {
    this.path = `api/estado-conservacao-ibp`;
  }


  atualizarSituacao(situacao, id) {
    return API.put(`${this.path}/atualizarSituacao/${situacao}/${id}`);

  }

  salvar(estadoConservacao) {
    return API.post(`${this.path}/salvar`, estadoConservacao, {

    }, {
      headers: { 'Content-Type': 'application/json' }
    });

  }


}

export default EstadoConservacaoIBPService;
